import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from './preview-code.module.css';

// linkPreview is the button that enable the display
// value is the short code that are displayed
export default function PreviewCode({ linkPreview = true, value }) {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(!linkPreview);

    const displayCode = React.useCallback(() => {
        setOpen(true);
    }, []);

    if (open) {
        return <div className={Style['preview-card']}>{value}</div>;
    }

    return (
        <div className={Style['link-display-code']}>
            <span onClick={displayCode}>
                <Icon name="eye" /> {t('modules.edit.display-code')}
            </span>
        </div>
    );
}

PreviewCode.propTypes = {
    linkPreview: PropTypes.bool,
    value: PropTypes.string.isRequired
};

PreviewCode.defaultProps = {
    linkPreview: false
};
